import React, { useEffect, useState } from 'react';
import network from '../../../assets/sso/networks.svg';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { UserData } from '../../../types/user.types';
import { NETWORKS } from '../../../constants/networks.config';
import NetworkItem from '../../../components/NetworkItem';
import { selectIsSsoUser, selectUserId } from '../../../selectors/userSelectors';

const Networks: React.FC = () => {
    const [user, setUser] = useState<UserData | null>(null);
    const userId = useSelector(selectUserId);
    const isSsoUser = useSelector(selectIsSsoUser);

    useEffect(() => {
        if (userId === undefined) {
            return;
        }

        void axios.get(`/api/users/` + userId).then(response => {
            setUser(response.data);
        });
    }, [userId]);

    return (
        <div className="flex flex-col">
            <div className="flex items-center justify-start gap-2 w-full">
                <img className="h-[40px]" src={network} alt="networks icon" />
                <div
                    className={
                        'font-medium medium-small ' + (!isSsoUser ? 'text-heavy' : 'text-medium')
                    }
                >
                    Mes réseaux
                </div>
            </div>
            {user ? (
                <div className="flex flex-col mt-6 gap-2 w-full">
                    {NETWORKS.map(networkConfig => (
                        <NetworkItem
                            key={networkConfig.key}
                            logo={networkConfig.logo}
                            displayName={networkConfig.displayName}
                            variant="status"
                            isConnected={!!user[networkConfig.key]}
                            sizeClass="small"
                        />
                    ))}
                </div>
            ) : (
                <p>Chargement...</p>
            )}
        </div>
    );
};

export default Networks;
